import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import { db, storage, auth } from '../config';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const uploadDefaultSnakeImage = async () => {
  try {
    if (!auth.currentUser) {
      throw new Error('Must be logged in to upload images');
    }
    
    console.log('Uploading as user:', auth.currentUser.email);
    console.log('Starting image upload...');
    const response = await fetch('https://placehold.co/1024x768/1F2937/FFFFFF?text=Snake+Game');
    if (!response.ok) {
      console.error('Failed to fetch image:', response.status, response.statusText);
      throw new Error('Failed to fetch placeholder image');
    }
    
    const blob = await response.blob();
    console.log('Image fetched, size:', blob.size, 'bytes');
    
    // Log storage info
    console.log('Storage ref:', storage);
    const storageRef = ref(storage, 'game-images/default-snake.jpg');
    console.log('Storage ref path:', storageRef.fullPath);

    try {
      await uploadBytes(storageRef, blob);
      console.log('Image uploaded to storage');
    } catch (uploadError) {
      console.error('Upload error details:', uploadError);
      throw uploadError;
    }
    
    const url = await getDownloadURL(storageRef);
    console.log('Got download URL:', url);
    return url;
  } catch (error) {
    console.error('Detailed error in uploadDefaultSnakeImage:', error);
    if (error instanceof Error) {
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
    }
    throw error;
  }
};

export const initializeSnakeGame = async () => {
  try {
    console.log('Checking for existing Snake game...');
    const gamesRef = collection(db, 'games');
    const q = query(gamesRef, where('title', '==', 'Snake'));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      console.log('No existing Snake game found, creating...');
      const imageUrl = await uploadDefaultSnakeImage();
      
      await addDoc(gamesRef, {
        title: 'Snake',
        description: 'Play this Classic snake game. Eat food to grow longer and earn tokens!',
        url: '/games/snake',
        imageUrl,
        isActive: true,
        addedDate: new Date(),
        category: 'arcade',
        requiredTokens: 0
      });
      console.log('Snake game created successfully');
    } else {
      console.log('Snake game already exists');
    }
  } catch (error) {
    console.error('Error in initializeSnakeGame:', error);
    throw error;
  }
}; 